import { createContext } from "react";
import { NetworkContextType } from "src/types/NetworkContext";

export const NetworkContext = createContext<NetworkContextType|null>(null);
